import React, { useMemo } from "react";
import classes from "./PageHeader.scss";
import classNames from "classnames";
import { Avatar, PageHeader } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import {
  SUBMISSION_TYPE_CUSTOM,
  CAN_MANAGE_IA_EA_PERMISSION,
} from "Projects/Constants/stringConstants";
import SubmissionLockStatus from "./components/SubmissionLockStatus";
import DeadlineComplete from "./components/DeadlineComplete";

import {
  getProjectDeadlinesDetailsText,
  getProjectGroupNameForAvatar,
  getIsUploadInProgress,
} from "Projects/modules/Utils";
import { isIEAssessment } from "Projects/modules/ProjectModules";
import ACLStorage from "lib/aclService";

const PageHeaderComponent = props => {
  const {
    deadlineDetails,
    onGoToBack,
    projectGroupType,
    projectDetailsWithTask,
    rightContainer,
    onUpdateProjectDeadlineSubmission,
    onUpdateProjectDeadline,
    headerTitle,
    projectGroupSubType,
    progressOfUploads,
    testId,
  } = props;
  const { t } = useI18n(["common", "project"]);

  const {
    title,
    dueOn,
    closesOn,
    isStudentSubmissionEnabled,
    submission,
    isDeadlineAllDay,
  } = deadlineDetails;
  const { type: submissionType } = submission || {};

  //TODO jatin, can this be made common
  const { dueDateSubtext, closeDateSubtext } = getProjectDeadlinesDetailsText({
    dueOn,
    closesOn,
    isDeadlineAllDay,
    t,
  });

  const { acronym, color } = getProjectGroupNameForAvatar({
    projectGroupType,
    t,
    projectGroupSubType,
  });

  const isSubmissionTypeCustom = submissionType === SUBMISSION_TYPE_CUSTOM;

  const pageHeaderRightComponent = useMemo(() => {
    if (rightContainer) return;

    const {
      id: projectTaskId,
      isComplete: isDeadlineComplete,
      latestSubmissionResponse,
    } = projectDetailsWithTask || {};

    const {
      isReturned: isSubmissionReturned,
      returnedAt,
      isLocked: isSubmissionLocked,
      id: submissionId,
      itemResponses: projectSubmissionItemResponses,
      status,
    } = latestSubmissionResponse || {};

    const isProjectGroupIEAssessment = isIEAssessment({
      projectGroupSubType,
    });

    const canManageIAEA = isProjectGroupIEAssessment
      ? ACLStorage.getPermissionValue(CAN_MANAGE_IA_EA_PERMISSION)
      : true;

    if (!canManageIAEA) {
      return null;
    }

    const isUploadInProgress = getIsUploadInProgress({
      progressOfUploads,
      itemResponses: projectSubmissionItemResponses,
    });

    if (isStudentSubmissionEnabled) {
      return (
        <>
          {/* {isSubmissionTypeCustom ? (
            <RequestResubmission
              isSubmissionReturned={isSubmissionReturned}
              disabled={
                !_.includes([TURNED_IN_LATE, TURNED_IN_ON_TIME], status)
              }
              onUpdateProjectDeadlineSubmission={
                onUpdateProjectDeadlineSubmission
              }
              submissionId={submissionId}
              returnedAt={returnedAt}
            />
          ) : null} */}
          <SubmissionLockStatus
            isSubmissionLocked={isSubmissionLocked}
            submissionId={submissionId}
            onUpdateProjectDeadlineSubmission={
              onUpdateProjectDeadlineSubmission
            }
            disabled={isUploadInProgress}
            testId={testId}
          />
          <DeadlineComplete
            isDeadlineComplete={isDeadlineComplete}
            projectTaskId={projectTaskId}
            onUpdateProjectDeadline={onUpdateProjectDeadline}
            isUploadInProgress={isUploadInProgress}
            testId={testId}
          />
        </>
      );
    } else {
      return (
        <DeadlineComplete
          isDeadlineComplete={isDeadlineComplete}
          projectTaskId={projectTaskId}
          onUpdateProjectDeadline={onUpdateProjectDeadline}
          isUploadInProgress={isUploadInProgress}
          testId={testId}
        />
      );
    }
  });

  return (
    <PageHeader dsVersion="2.0">
      <PageHeader.Left
        testId={testId}
        width="40%"
        title={headerTitle ? headerTitle : title}
        icon={
          <Avatar
            dsVersion="2.0"
            name={acronym}
            shape="square"
            size="large"
            color={color}
          />
        }
        subtitle={
          <div className={classNames(classes.subtitleContainer, "text-body-s")}>
            <span> {dueDateSubtext} </span>
            <span className={classes.dot}>.</span>
            <span> {closeDateSubtext} </span>
          </div>
        }
        onBackClick={onGoToBack}
      />
      <PageHeader.Right>
        {rightContainer ? rightContainer : pageHeaderRightComponent}
      </PageHeader.Right>
    </PageHeader>
  );
};

export default PageHeaderComponent;
